import { Country } from 'clients/countries';
import { useCountries } from 'clients/countries';
import { PropsWithChildren } from 'react';

interface CountryProviderState {
  countries?: Country[];
}

interface CountryProviderProps {
  children: (e: CountryProviderState) => any;
}

function CountryProvider({
  children,
}: PropsWithChildren<CountryProviderProps>) {
  const { data: countries = [] } = useCountries();
  return children({ countries });
}

export default CountryProvider;
